
export const ENGLISH_LANGUAGE_TEXTS = {
  // Search results
  TIPO_MATERIAL_DELTALLE_TITLE : 'Typology',
  ACBABADO_DELTALLE_TITLE: 'Finish',
  ESPESOR_MATERIAL_DELTALLE_TITLE: 'Thickness',
  COLOR_MATERIAL_DELTALLE_TITLE: 'Colour',
  RANGO_ANCHO_DELTALLE_TITLE: 'Width range',
  RANGO_ALTO_DELTALLE_TITLE: 'Height range',
  PIEZAS_DELTALLE_TITLE: 'Pieces',
  NUMERO_LOTE: 'Lot Number',
  BLOQUE_TEXT: 'Block',
  PAQUETE_TITLE: 'Bundle',
  PAQUETES_TITLE: 'Bundles',
  NO_RESULTS_TITLE: 'No results',
  ANCHO_MATERIAL_TITLE: 'Width',
  LARGO_MATERIAL_TITLE: 'Length', //
  ALTO_MATERIAL_TITLE: 'Height', //
  MEDIDAS_TITLE: 'Measure',
  MEDIDAS_ANCHO_TITLE: 'Width',
  MEDIDAS_ALTO_TITLE: 'Height',
  SLAB_NUMBER_TITLE: 'Slab No.',
  CARGANDO: 'Loading...',
  // filters
  TIPO_MATERIAL_FILTER_TITLE: 'Typology',
  ACABADO_MATERIAL_FILTER_TITLE: 'Finish',
  ESPESOR_FILTER_TTILE: 'Thickness',
  DISPONIBILIDAD_FILTER_TITLE: 'Availability',
  COLOR_MATERIAL_TITLE: 'Colour',
  USO_MATERIAL_FILTER_TITLE: 'Applications',
  ORIGEN_MATERIAL_TITLE: 'Origin',
  RANGO_MEDIDA_FILTER_TITLE: 'Measurement range',
  RANGO_PRECIO_FILTER_TITLE: 'Price range',
  RANGO_SUPERFICIE_FILTER_TITLE: 'Surface range',
  // barra filtros
  RESULTS_CONTER_TITLE: 'Results',
  BORRAR_FILTROS_TITLE: 'Clear filters',
  FILTERS_BAR_PLACEHOLDER: '',
  FILTERS_BAR_KEYWORD_PLACEHOLDER: 'Search',
  // detalles
  BOOKMATCH_BUTTON_TEXT: 'See Bookmatch',
  // materiales similares
  MATERIALES_SIMILARES_TITLE: 'Products of similar shade',
  // medidas
  CM: 'cm', //
  PULGADAS: 'Inch', //
  METROS: 'Meters',
  SUPERFICIE: 'Surface',
  //detalles
  SIMILARES_TITLE: 'Products of similar shade',
  VER_BOOKMATCH: 'See Bookmatch',
  FICHA_DATOS: 'DATA SHEET',
  SI: 'Yes',
  NO: 'No',
  ATRAS: 'BACK',
  // rango
  A: 'to',
  // menu  
  PRODUCTOS_MENU : 'Products',
  LIBRARY_MENU : 'Library',
  CATALOGOS_MENU : 'Catalogues',
  SERVICIOS_MENU : 'Services',
  SHOWROOM_MENU : 'Showroom',
  NOSOTROS_MENU : 'About us',
  CONTACTO_MENU : 'Contact us',
  PRODUCTOS_MENU_LINK : '/products/',
  CATALOGOS_MENU_LINK : '/catalogues/',
  SERVICIOS_MENU_LINK : '/Services/',
  SHOWROOM_MENU_LINK : '/showroom/',
  NOSOTROS_MENU_LINK : '/about-us/',
  CONTACTO_MENU_LINK : '/contact-us/'
}
